/**
 * 自定义 SVG 图标组件
 * 品牌 Logo (HvuiCt)、皇冠图标等
 */
import { Box } from '@mui/material';
import { COLORS } from '@/theme/tokens';

/**
 * HvuiCt 品牌 Logo（图片版）
 * 使用 public/logo.png 品牌Logo图片
 */
export function HvuiCtLogo({ height = 28 }: { height?: number }): JSX.Element {
  return (
    <Box
      component="img"
      src="/logo.png"
      alt="HyuiCT 虹宇创发"
      sx={{ height, width: 'auto', objectFit: 'contain' }}
    />
  );
}

/**
 * Logo 文字版（仅用于无法显示图片的场景）
 * "HvuiCt" 使用品牌红色 + "虹宇创发" 使用深灰色，字体加粗
 */
export function HvuiCtTextLogo(): JSX.Element {
  return (
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
      <Box component="span" sx={{ fontSize: '22px', fontWeight: 800, color: COLORS.primary, letterSpacing: '-0.5px' }}>
        HvuiCt
      </Box>
      <Box component="span" sx={{ fontSize: '16px', fontWeight: 700, color: COLORS.textPrimary }}>
        红宇创发
      </Box>
    </Box>
  );
}

/**
 * 皇冠图标
 * 金色皇冠，用于代理商等级展示
 */
export function CrownIcon({
  width = 20,
  height = 20,
}: {
  width?: number;
  height?: number;
}): JSX.Element {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 6L6 18H18L21 6L16 9L12 4L8 9L3 6Z"
        fill={COLORS.gold}
        stroke={COLORS.gold}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <rect x="6" y="18" width="12" height="2" fill={COLORS.gold} />
    </svg>
  );
}

/**
 * 星星图标（实心）
 * 用于星级评价
 */
export function StarIcon({
  filled = true,
  width = 16,
  height = 16,
}: {
  filled?: boolean;
  width?: number;
  height?: number;
}): JSX.Element {
  const color = filled ? COLORS.gold : COLORS.starInactive;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2L14.39 8.26L21 9L16 13.64L17.55 20.5L12 17.06L6.45 20.5L8 13.64L3 9L9.61 8.26L12 2Z" />
    </svg>
  );
}
